import React from "react";
import { Modal } from "antd";

import style from "./styles.module.scss";
const ModalForm = props => {
  const {
    title,
    styles,
    onCancel,
    onSubmit,
    isOpen,
    children,
    footer,
    labelSubmit,
    customWidth,
    destroyOnClose,
    okType,
    closeIcon,
    maskClosable,
  } = props;

  return (
    <Modal
      destroyOnClose={destroyOnClose}
      title={title}
      open={isOpen}
      onOk={onSubmit}
      onCancel={onCancel}
      style={styles}
      footer={footer}
      okText={labelSubmit}
      width={customWidth}
      okType={okType}
      wrapClassName={style.modalForm}
      closeIcon={closeIcon}
      maskClosable={maskClosable}
    >
      {children}
    </Modal>
  );
};

export default ModalForm;
